import type { SVGProps } from 'react'
const SvgSySettingAltLine = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="m5.31 6.693-1.324 2.5C3.258 10.568 2.894 11.255 2.894 12s.364 1.433 1.092 2.807l1.324 2.5c.823 1.556 1.235 2.333 1.949 2.763s1.594.43 3.353.43h2.776c1.76 0 2.64 0 3.353-.43s1.126-1.207 1.95-2.763l1.323-2.5c.728-1.375 1.092-2.062 1.092-2.807s-.364-1.433-1.092-2.807l-1.324-2.5c-.823-1.556-1.235-2.333-1.949-2.763s-1.594-.43-3.354-.43h-2.775c-1.76 0-2.64 0-3.353.43s-1.126 1.207-1.95 2.763"
		/>
		<circle cx={12} cy={12} r={3} />
	</svg>
)
export default SvgSySettingAltLine
